<template>
  <div
    v-if="!disabled_pass && !disabled"
    class="cursor-pointer flex hover:font-medium items-center w-max" 
    @click.stop="add()"
  >
    <span class="plus-button 2xl:h-10 2xl:w-10 2xl:mt-2">
      <icon name="plus" />
    </span>
    <span
      v-if="responsive"
      class="text-base text-gray-600 ml-3 hidden md:inline flex-initial"
    >
      {{ libelle }}
    </span>
    <span
      v-else
      class="text-base text-gray-600 ml-3 flex-initial"
    >
      {{ libelle }}
    </span>
    <icon
      v-if="withDropdown"
      name="chevron-down"
      class="ml-2.5 text-teal-600"
    />
  </div>
</template>

<script>
import Icon from './../Icon';
import Constants from './../../constants';

export default {
  name: 'AddButton',
    
  components:{
    Icon,
  },

  props:{
    libelle: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    withDropdown:{
      type: Boolean,
      required: false,
      default: false,
    },
    responsive: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data: function () {
    return {
      disabled_pass: false,
      constants:Constants,
    };
  },

  mounted(){
    // Manage edit permission for neopass pages
    if(this.$route.path.includes('form/neopass')){
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];

      if(this.$can(page+'_edit', idpass) || page === Constants.PAGE_NEOPASS_FORM_DOCUMENTS){
        this.disabled_pass = false;
      }
      else{
        this.disabled_pass =  true;
      }
    }else{
      this.disabled_pass = false;
    }
  },

  methods:{
    add(){
      this.$emit('add');
    }
  }
};
</script>